<template>
    <div class="column is-full ">
        <div class="columns is-multiline is-centered">
            <div class="colum is-two-thirds has-text-centered">
                <b-field class="m-t-5 m-b-5">
                    <b-select 
                    expanded
                    v-model="order.status"
                    >
                        <option value="D" icon="times">Rechazada</option>
                        <option value="R" icon="undo">Rembolsada</option>
                        <option value="SA" icon="search">En verificacion</option>
                        <option value="P" icon="hourglass-half">Pendiente</option>
                        <option value="A" icon="thumbs-up">Aprobado</option>
                        <option value="S" icon="truck">Enviada</option>
                        <option value="F" icon="check-circle">Entregada al cliente</option>
                    </b-select>
                </b-field>
            </div>
            <div class="column is-full has-text-centered">
                <b-button
                rounded
                type="is-primary"
                @click="applyChange(false)"
                >
                    <b-icon icon="save" size="is-small"></b-icon>
                    Guardar cambio
                </b-button>

                <b-button
                rounded
                type="is-primary"
                class="m-l-5"
                @click="applyChange(true)"
                >
                    <b-icon icon="paper-plane" size="is-small"></b-icon>
                    Guardar y notificar cambio a cliente
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        order:{
            type:Object,
            default:new Object({})
        }
    },

    methods:{
        applyChange(notify){
            this.$emit("updateOrder", notify)
        }
    }
}
</script>

<style lang="scss" scoped>
.card{
    border:0px #fff solid !important;
    
}

</style>